/**
 * Shared overall-score display formatter — ONE display value for the same
 * fact on every surface (STAGE4-FIX-B Part 3, owner ruling): the recent-
 * reports list, the report-page score ring, the enterprise activity feed and
 * the PDF cover all render the identical rounded integer (71, never 71.2).
 *
 * The engine keeps full precision (analysis.overallScore, two decimals);
 * rounding here is DISPLAY-ONLY (§A2 — render, never recalculate).
 *
 * Isomorphic — number/string only, safe to import from browser-bundled
 * dashboard components.
 *
 * @module shared/scoreDisplay
 */

/**
 * The display integer for an overall score. NaN/null-safe.
 * @param {number} score
 * @returns {number}
 */
export function roundedOverallScore(score) {
  const n = Number(score);
  return Number.isFinite(n) ? Math.round(n) : 0;
}

/**
 * The display string for an overall score — em dash when absent.
 * @param {number|null|undefined} score
 * @returns {string}
 */
export function formatOverallScore(score) {
  if (score === null || score === undefined || !Number.isFinite(Number(score))) return '—';
  return String(roundedOverallScore(score));
}
